module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "AccountIn"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('AccountIn_title')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "acon"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('AccountIn_rmno')))]), _vm._v(" "), _c('span', {
    staticClass: "inv"
  }, [_vm._v(_vm._s(_vm.rmno))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('AccountIn_name')))]), _vm._v(" "), _c('span', {
    staticClass: "inv"
  }, [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('AccountIn_taCode')) + " "), _c('i', {
    staticClass: "must"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', {
    staticClass: "inv select",
    on: {
      "click": _vm.getTaCode
    }
  }, [_vm._v(_vm._s(_vm.feeInfo.taCode)), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feeInfo.taCode),
      expression: "feeInfo.taCode"
    }]
  }, [_vm._v(" -- ")]), _vm._v(_vm._s(_vm.accountName) + "\n          "), _c('i', {
    staticClass: "iconfont icon-xia"
  })])]), _vm._v(" "), (_vm.isRCV) ? _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('AccountIn_clubCard')) + " "), _c('i', {
    staticClass: "must"
  }, [_vm._v("*")])]), _vm._v(" "), _c('popSearch', {
    staticClass: "inv select is-popup",
    attrs: {
      "type": "mem",
      "anchor": "cardNo",
      "searchNow": false
    },
    on: {
      "onSelect": _vm.onSelectCard
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAR) ? _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('incomeAccount_msg_ar_select_company')) + " "), _c('i', {
    staticClass: "must"
  }, [_vm._v("*")])]), _vm._v(" "), _c('popSearchArPayGroup', {
    staticClass: "inv select is-popup",
    attrs: {
      "anchor": "name",
      "searchNow": false
    },
    on: {
      "onSelect": _vm.onSelectArPayGroup
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isRCV) ? _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('incomeAccount_select_subAccount_title')) + " "), _c('i', {
    staticClass: "must"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "inv select is-popup"
  }, [_c('gpicker', {
    ref: "subAccount",
    attrs: {
      "placeholder": _vm.$t('incomeAccount_select_subAccount_pl')
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('AccountIn_money')) + " "), _c('i', {
    staticClass: "must"
  }, [_vm._v("*")])]), _vm._v(" "), (_vm.isCheckout) ? _c('span', {
    staticClass: "inv"
  }, [_vm._v(_vm._s(_vm.feeInfo.money))]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.feeInfo.money),
      expression: "feeInfo.money"
    }],
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('AccountIn_money_placeholder')
    },
    domProps: {
      "value": (_vm.feeInfo.money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.feeInfo, "money", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.isCheckout) ? _c('div', [_c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('fangTXQ_coMsg')) + " :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.coMsg))])]), _vm._v(" "), (_vm.showPayBtn) ? _c('div', {
    staticClass: "btns-wrap"
  }, [_c('div', {
    staticClass: "staRBtn"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.goScanPay
    }
  }, [_vm._v(_vm._s(_vm.$t('scanPay_title')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "staRBtn"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.surePay
    }
  }, [_vm._v(_vm._s(_vm.$t('AccountIn_save')) + "\n            ")])])]) : _c('div', {
    staticClass: "btns-wrap"
  }, [_c('div', {
    staticClass: "staRBtn fullWidth"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.surePay
    }
  }, [_vm._v(_vm._s(_vm.$t('AccountIn_save')) + "\n            ")])])])]) : _c('div', [_c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('AccountIn_taNo')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.feeInfo.taNo),
      expression: "feeInfo.taNo"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('memberRegister_cardSrc_placeholder')
    },
    domProps: {
      "value": (_vm.feeInfo.taNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.feeInfo, "taNo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('AccountIn_taRemark')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.feeInfo.taRemark),
      expression: "feeInfo.taRemark"
    }],
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.feeInfo.taRemark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.feeInfo, "taRemark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "staRBtn"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('AccountIn_save')) + "\n            ")])])])])])]), _vm._v(" "), _c('mt-popup', {
    staticClass: "AccountCode",
    attrs: {
      "position": "right",
      "modal": false
    },
    model: {
      value: (_vm.disTaCode),
      callback: function($$v) {
        _vm.disTaCode = $$v
      },
      expression: "disTaCode"
    }
  }, [_c('ACode', {
    ref: "selectAccount",
    on: {
      "cancel": function($event) {
        _vm.disTaCode = false
      },
      "select": _vm.selectAccount
    }
  })], 1), _vm._v(" "), _c('actionsheet', {
    attrs: {
      "actions": _vm.actions,
      "cancelText": _vm.$t('cancel')
    },
    model: {
      value: (_vm.sheetVisible),
      callback: function($$v) {
        _vm.sheetVisible = $$v
      },
      expression: "sheetVisible"
    }
  }), _vm._v(" "), _c('mt-popup', {
    staticClass: "selectShift select-wrap",
    attrs: {
      "popup-transition": "popup-fade"
    },
    model: {
      value: (_vm.showAddModal),
      callback: function($$v) {
        _vm.showAddModal = $$v
      },
      expression: "showAddModal"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('MessageBox_checkOutAdd')))]), _vm._v(" "), _c('div', {
    staticClass: "select-list-wrap"
  }, [_c('mt-radio', {
    attrs: {
      "options": _vm.shiftArr
    },
    model: {
      value: (_vm.currentCode),
      callback: function($$v) {
        _vm.currentCode = $$v
      },
      expression: "currentCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    staticClass: "unSure",
    on: {
      "click": function($event) {
        _vm.showAddModal = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "sure",
    on: {
      "click": _vm.addReceiveP
    }
  }, [_vm._v(_vm._s(_vm.$t('determine')) + "\n      ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-ed6e80ba","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/page/fangTXQ/IncomeAccount.vue
// module id = 1848
// module chunks = 107